/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { connect, ConnectedProps } from 'react-redux';
import { MoreInfoRequestAlert } from './MoreInfoRequestAlert';
import { setSelectedThread } from 'blb-redux/inbox';

export type ReduxProps = ConnectedProps<typeof connector>;

const mapDispatchToProps = {
  setSelectedThread,
};

const connector = connect(null, mapDispatchToProps);

export const MoreInfoRequestAlertContainer = connector(MoreInfoRequestAlert);
